import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export async function getColonistUsername(originalUsername, userId) {
    if (!UIUtilsEjsVariables.isUserOnDiscord) return originalUsername;
    if (userId == undefined) return originalUsername;
    const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.username(userId), undefined);
    if (response == undefined) return originalUsername;
    const responseData = response.json;
    var _responseData_username;
    return (_responseData_username = responseData.username) !== null && _responseData_username !== void 0 ? _responseData_username : originalUsername;
}
